"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayEnumerable = void 0;
const BasicEnumerable_1 = require("./BasicEnumerable");
class ArrayEnumerable extends BasicEnumerable_1.BasicEnumerable {
    constructor(factory, srcGenerator, srcArr) {
        super(factory, srcGenerator);
        this.srcArr = srcArr;
    }
    /**
     * Determines whether all elements of a sequence satisfy a condition.
     * @example
     * ```typescript
     * const numbers = [1, 2, 3, 4];
     * const areAllNumbersEven = from(numbers).all(x => x % 2 === 0); // false
     * ```
     * @param predicate A function to test each element for a condition.
     * @returns true if every element of the source sequence passes the test in the specified predicate, or if the sequence is empty; otherwise, false.
     */
    all(predicate) {
        return this.srcArr.every(predicate);
    }
    any(predicate) {
        if (!predicate) {
            return this.srcArr.length > 0;
        }
        return this.srcArr.some(predicate);
    }
    count(predicate) {
        if (predicate) {
            return super.count(predicate);
        }
        return this.srcArr.length;
    }
    /**
     * Returns the element at a specified index in a sequence or null if the index is out of range.
     * A negative index can be used to get element starting from the end.
     * @example
     * ```typescript
     * const items = [1, 2, 3];
     * const indexZero = from(items).elementAtOrDefault(0); // Will be 1
     * const willBeNull = from(items).elementAtOrDefault(10); // Will be null.
     * const last = from(items).elementAtOrDefault(-1); // 3
     * ```
     * @param index The zero-based index of the element to retrieve.
     * @returns The element at the specified position in the source sequence.
     */
    elementAtOrDefault(index) {
        if (index < 0) {
            const target = this.srcArr.length + index;
            if (target < 0) {
                return null;
            }
            return this.srcArr[target];
        }
        if (index >= this.srcArr.length) {
            return null;
        }
        return this.srcArr[index];
    }
    lastOrDefault(predicate) {
        const arr = this.srcArr;
        if (predicate) {
            for (let i = arr.length - 1; i >= 0; i--) {
                if (predicate(arr[i], i)) {
                    return arr[i];
                }
            }
        }
        else {
            if (arr.length > 0) {
                return arr[arr.length - 1];
            }
        }
        return null;
    }
}
exports.ArrayEnumerable = ArrayEnumerable;
//# sourceMappingURL=ArrayEnumerable.js.map